// extracted by mini-css-extract-plugin
module.exports = {"go_top":"GoTop_go_top__ftn2W"};